import {
  ROLE_BASE_ANONYMOUS,
  ROLE_BASE_USER,
  ROLE_BASE_MANAGER,
  ROLE_BASE_ADMIN,
  ROLE_EVO_SB_ADMIN,
  ROLE_EVO_SUPER_ADMIN,
  ROLE_EVO_GLOBAL_ADMIN,
} from '../constants';

// Check that user has a role that is at least as high in the role hierarchy as the required role
// anonymous < user < manager < admin < sbAdmin < superAdmin < GA

export function checkRole(userRoles, requiredRole) {
  let hasRole = false;
  // switch fallthrough creates userRoles >= requiredRole relationship
  /* eslint-disable no-fallthrough */
  switch (requiredRole) {
    default:
      return hasRole;
    case ROLE_BASE_ANONYMOUS:
      hasRole = hasRole || userRoles.includes(ROLE_BASE_ANONYMOUS);
    case ROLE_BASE_USER:
      hasRole = hasRole || userRoles.includes(ROLE_BASE_USER);
    case ROLE_BASE_MANAGER:
      hasRole = hasRole || userRoles.includes(ROLE_BASE_MANAGER);
    case ROLE_BASE_ADMIN:
      hasRole = hasRole || userRoles.includes(ROLE_BASE_ADMIN);
    case ROLE_EVO_SB_ADMIN:
      hasRole = hasRole || userRoles.includes(ROLE_EVO_SB_ADMIN);
    case ROLE_EVO_SUPER_ADMIN:
      hasRole = hasRole || userRoles.includes(ROLE_EVO_SUPER_ADMIN);
    case ROLE_EVO_GLOBAL_ADMIN:
      return hasRole || userRoles.includes(ROLE_EVO_GLOBAL_ADMIN);
  }
  /* eslint-enable no-fallthrough */
}



// WEBPACK FOOTER //
// ./src/helpers/checkRoles.js